<template>
<div class="snippet theme-color-snippet">
    <div class="form-group row">
      <div class="col-lg-3">
        <label>Footer Color</label>
        <VPopper  arrow hover style="display:inline-block" class="dark">
                                      <i class="fa fa-info-circle" style="font-size:16px"></i>
                                      <template #content>
                                        Enter hexa color code e.g #abc234
                                      </template>
                                    </VPopper>
        <div class="input-group color" data-plugin-colorpicker>
          <input
              type="color"
              class="form-control"
              name="footer_color"
              :value="item.footer_color"
              @input="updateFooterColor "/>
        </div>
      </div>
      
    </div>

    <div class="form-group row">
      <div class="col-lg-3">
        <label>Button Color</label>
        <VPopper  arrow hover style="display:inline-block" class="dark">
                                      <i class="fa fa-info-circle" style="font-size:16px"></i>
                                      <template #content>
                                        Enter hexa color code e.g #abc234
                                      </template>
                                    </VPopper>
        <div class="input-group color" data-plugin-colorpicker>
          <input
              type="color"
              class="form-control"
              name="button_color"
              :value="item.button_color"
              @input="updateButtonColor "/>
        </div>
      </div>

       <div class="col-lg-3">
        <label>Button Text Color</label>
        <VPopper  arrow hover style="display:inline-block" class="dark">
                                      <i class="fa fa-info-circle" style="font-size:16px"></i>
                                      <template #content>
                                        Enter hexa color code e.g #abc234
                                      </template>
                                    </VPopper>
        <div class="input-group color" data-plugin-colorpicker>
          <input
              type="color"
              class="form-control"
              name="button_text_color"
              :value="item.button_text_color"
              @input="updateButtonTextColor "/>
        </div>
      </div>
    </div>

       <div class="form-group row">
   
       <div class="col-lg-3">
        <label>Landing Page Theme Color</label>
        <VPopper  arrow hover style="display:inline-block" class="dark">
                                      <i class="fa fa-info-circle" style="font-size:16px"></i>
                                      <template #content>
                                        Enter hexa color code e.g #abc234
                                      </template>
                                    </VPopper>
        <div class="input-group color" data-plugin-colorpicker>
          <input
              type="color"
              class="form-control"
              name="landing_page_theme_color"
              :value="item.landing_page_theme_color"
              @input="updateLandingPageThemeColor "/>
        </div>
      </div>
      </div>
      
   

</div>
</template>



<script>
import {mapActions, mapGetters} from "vuex";
import _ from 'lodash';

export default {
    name: "ThemeContentsTab",
    components: {
     
     
  },
    data() {
        return {
            event_theme: null,
        };
    },
    computed: {
        ...mapGetters("LandingPageSettingsSingle", [
            "item",
            "event_type",
            "skyboxes",
            "environments"
        ])
    },
    watch: {
        
    },
    methods: {
        ...mapActions("LandingPageSettingsSingle", [
            "setEvent",
            "setButtonColor",
            "setFooterColor",
            "setButtonTextColor",
            "setLandingPageThemeColor"
        ]),
        updateButtonColor(e){
            this.setButtonColor(e.target.value);
        },
        updateFooterColor(e){
            this.setFooterColor(e.target.value);
        },
        updateButtonTextColor(e){
            this.setButtonTextColor(e.target.value);
        },
        updateLandingPageThemeColor(e){
            this.setLandingPageThemeColor(e.target.value);
        }
        
      
    }
}
</script>

<style scoped>

</style>